/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { UtilsService } from '../../../../core/services';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-base',
    template: '<div></div>',
})
export abstract class WidgetBaseComponent implements OnDestroy {
    @ViewChild('widget', { read: ElementRef, static: true })
    public elRef: ElementRef;

    protected destroyed$: Subject<boolean> = new Subject();

    protected constructor(
        public utils: UtilsService,
    ) {
    }

    public ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
